// extracted by mini-css-extract-plugin
export default {"grid":"ContentGrid_grid__NqmS6"};